/**
 * Application scripts
 * Usage: Add imports here for third party scripts, such as GSAP
 *
 * Example: import { gsap } from gsap;
 */

import { gsap } from './app/gsap';
import { ScrollTrigger } from './app/ScrollTrigger.js';
import { ScrollSmoother } from './app/ScrollSmoother.js';
import { ScrollToPlugin } from './app/ScrollToPlugin.js';
//import { tsParticles } from "@tsparticles/engine";
import "particles.js";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin);

if (!document.body.classList.contains('page-template-page-ticket-calendar') && !document.body.classList.contains('page-template-page-ots-ticket-calendar')) {
	// ScrollSmoother.create({
	// 	smooth: 1,
	// 	effects: true,
	// 	smoothTouch: 0.3
	// });
}

function animatedTicker() {
	const tickerInner = document.querySelector('.site-info-ticker-banner__inner');
	const tickerContent = document.querySelector('.site-info-ticker-banner__inner-content');
	const contentWidth = tickerContent.offsetWidth;

	function animateTicker() {
		gsap.to(tickerInner, {
			x: () => -contentWidth,
			ease: 'none',
			duration: 10,
			repeat: -1,
			modifiers: {
				x: gsap.utils.unitize((x) => parseFloat(x) % contentWidth)
			}
		});
	}

	function tickerSize() {
		const tickerHeight = document.querySelector('.site-info-ticker-banner');
		let offsetHeight = 0;

		if (tickerHeight) {
			offsetHeight = tickerHeight.offsetHeight;
		} else {
			offsetHeight = 48;
		}
		document.documentElement.style.setProperty('--info-ticker-height', `${ offsetHeight }px`);
	}

	function tickerVisibility() {
		const infoTicker = document.querySelector('.site-info-ticker-banner');
		const infoTickerOffsetTop = infoTicker.offsetTop;
		const infoTickerHeight = infoTicker.offsetHeight;
		const infoTickerBottom = infoTickerOffsetTop + infoTickerHeight;

		if (window.scrollY >= infoTickerBottom) {
			infoTicker.classList.add('site-info-ticker-banner--is-visible');
		} else {
			infoTicker.classList.remove('site-info-ticker-banner--is-visible');
		}
	}

	animateTicker();
	setTimeout(function() {
		tickerSize();
	}, 100);
	window.addEventListener('resize', () => {
		tickerSize();
		tickerVisibility();
	});
	window.addEventListener('scroll', tickerVisibility);
}

if (document.querySelector('.site-info-ticker-banner')) {
	animatedTicker();
}

// function smoothScrollToAnchor(_sel) {
//     _sel.addEventListener('click', function(e) {
//         e.preventDefault();

//         if (document.querySelector('.site-navigation__navicon--active') && document.body.classList.contains('site-navigation--open')) {
//             document.querySelector('.site-navigation__navicon').click();
//         }

//         if (e.target.parentNode.parentNode && e.target.parentNode.parentNode.classList.contains('site-navigation__sub-menu')) {
//             e.target.parentNode.parentNode.classList.remove('site-navigation__sub-menu--active');
//         }

//         if (e.target.parentNode.parentNode.parentNode && e.target.parentNode.parentNode.classList.contains('site-navigation__menu-item')) {
//             e.target.parentNode.parentNode.parentNode.querySelector('a').classList.remove('site-navigation__menu-item--active');
//         }

//         if (e.target.href.includes('#') && document.getElementById(e.target.href.split('#')[1])) {
//             const targetElementId = e.target.href.split('#')[1];
//             const targetElement = document.getElementById(targetElementId);

//             // Use GSAP to smoothly scroll to the element
//             gsap.to(window, {
//                 duration: 1, // Duration of the scroll (in seconds)
//                 scrollTo: {
//                     y: targetElement, // Element to scroll to
//                     offsetY: 100, // Optional: adjust the final scroll position
//                 },
//                 onComplete: () => {
//                     e.target.blur(); // Remove focus from the clicked link to avoid scroll lock
//                 }
//             });
//         } else {
//             window.location.href = e.target.href;
//         }
//     });
// }
// document.querySelectorAll('a[href*="#"]').forEach((_sel) => {
// 	smoothScrollToAnchor(_sel);
// });



    particlesJS("particles-js", {
      "particles": {
        "number": {
          "value": 60,
          "density": {
            "enable": true,
            "value_area": 800
          }
        },
        "color": {
          "value": "#ffffff"
        },
        "shape": {
          "type": "circle",
          "stroke": {
            "width": 0,
            "color": "#ffffff"
          },
        },
        "opacity": {
          "value": 0.3,
          "random": true,
          "anim": {
            "enable": true,
            "speed": 4,
            "opacity_min": 0.6,
            "sync": false
          }
        },
        "size": {
          "value": 2,
          "random": true,
          "anim": {
            "enable": true,
            "speed": 3,
            "size_min": 0.3,
            "sync": false
          }
        },
        "line_linked": {
          "enable": false,
        },
        "move": {
          "enable": true,
          "speed": 3,
          "direction": "none",
          "random": false,
          "straight": true,
          "out_mode": "bounce",
          "bounce": false,
          "attract": {
            "enable": false,
            "rotateX": 600,
            "rotateY": 1200
          }
        }
      },
      "interactivity": {
        "detect_on": "window",
        "events": {
          "onhover": {
            "enable": true,
            "mode": "bubble"
          },
          "resize": true
        },
        "modes": {
          "bubble": {
            "distance": 400,
            "size": 1.2,
            "duration": 2,
            "opacity": 0.8,
            "speed": 3
          },
        }
      },
      "retina_detect": true
    });
